import styled from 'styled-components';
import { Typography } from '@material-ui/core';

export const CustomTypography = styled(Typography)``;
